
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/contact",
      function () {
        return require("private-next-pages/[locale]/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/contact"])
      });
    }
  